import React from "react";

export function GrowGMAIL() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none">
      <g clipPath="url(#clip0_807_951)">
        <path d="M6.43089 38.7676L12.7585 38.0911L11.1157 22.7241L6.19874 15.9319L1.35144 16.9109L3.42916 36.3457C3.58934 37.8439 4.93263 38.9277 6.43089 38.7676Z" fill="#0085F7" />
        <path d="M34.4534 35.7721L40.7811 35.0956C42.2793 34.9354 43.3631 33.5921 43.203 32.0939L41.1252 12.6591L36.1876 12.7262L32.8107 20.4051L34.4535 35.7721L34.4534 35.7721Z" fill="#00A94B" />
        <path d="M31.5525 8.65328L28.5939 16.1433L32.8088 20.4045L41.1234 12.6586L40.7369 9.04285C40.3786 5.69148 36.348 4.1864 33.8806 6.48445L31.5525 8.65328Z" fill="#FFBC00" />
        <path fillRule="evenodd" clipRule="evenodd" d="M11.1145 22.7246L6.77286 15.6217L9.85818 10.9734L21.5752 17.9492L31.5527 8.6541L32.809 20.4053L22.8315 29.7004L11.1145 22.7246Z" fill="#FF4131" />
        <path d="M0.96495 13.2958L1.3515 16.9115L11.1157 22.7247L9.85942 10.9734L7.12543 9.34577C4.22796 7.62127 0.606663 9.94438 0.96495 13.2958Z" fill="#E51C19" />
      </g>
      <defs>
        <clipPath id="clip0_807_951">
          <rect width="40" height="40" fill="white" transform="translate(0 4.25195) rotate(-6.10218)" />
        </clipPath>
      </defs>
    </svg>
  );
}
